<template>
  <section class="mt-5 primal-page">
    <div class="row portfolio-container">
      <div class="col-sm-12 col-md-12 col-lg-6">
        <img src="/images/zimi/zimi-iner-logo.png" alt="" class="logo-img">
        <h1 class="main-heading">
         Smart Home Simplified
        </h1>
        <h2 class="sub-heading">
          technologies
        </h2>
        <div class="tech-img">
         <div class="tech-grid">
            <img src="/images/zimi/vue-icon.png" alt="">
            <img src="/images/zimi/nextjs-icon.png" alt="">
            <img src="/images/zimi/googleclud-icon.png" alt="">
            <img src="/images/primalplunge/Firebase.png" alt="">
            <img src="/images/primalplunge/MySQL.png" alt="">
            <!-- <img src="/images/primalplunge/google cloud.png" alt=""> -->
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-6 banner-right zimi">
        <div class="flex">
            <img src="/images/zimi/zimi-banner.png" alt="">
        </div>
      </div>
      <div class="second-grid">
        <div>
          <div class="inrto-img">
            <img src="/images/zimi/zimi-intro.png" alt="">
          </div>
        </div>
        <div>
          <h1 class="main-heading">
            introduction
          </h1>
          <h2 class="sub-heading">
           A Smarter Home Experience
          </h2>
          <p class="znap-p">
            Zimi transforms ordinary homes into intelligent living spaces. By powering smart switches, lighting, fans, and appliances through Powermesh technology and cloud connectivity, Zimi provides users complete control—via touch, voice, or app. Its intuitive UI and real-time energy analytics make smart living accessible and effortless.
          </p>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12">
        <h1 class="main-heading">our integration</h1>
      </div>
      <div class="col-sm-12 col-md-8 col-lg-8">
        <div class="integration-class">
          <p class="znap-p">
            We collaborated closely with the Zimi team to deliver a seamless user experience across its app and cloud ecosystem:
            <ul>
                <li>Developed a cross-platform mobile app for iOS and Android to control IoT devices.</li>
                <li>Integrated BLE-based Powermesh protocol and voice assistant support (Google Assistant, Alexa).</li>
                <li>Built energy usage dashboards, scheduling, auto-off timers, and Behavior Link switch pairing.</li>
                <li>Integrated firmware update controls and remote device management in the backend</li>
            </ul>
          </p>
        </div>
      </div>
      
      <div class="col-sm-12 col-md-4 col-lg-4">
        <div class="integration-img">
          <img src="/images/zimi/zimit-integration.png" alt="">
        </div>

      </div>
      <div class="second-grid">
        <div>
          <div class="img">
            <img src="/images/zimi/zimi-integrat.png" alt="">
          </div>
        </div>
        <div>
          <p class="znap-p">
            Smart Automation: Auto schedules, timed off features, Behavior Link for multi-switch setups.
            Voice Control: Hands-free control using Google Assistant or Alexa.
            Energy Insights: Live dashboard showing watts and cost estimates.
	        Secure Connectivity: Powermesh networking extends coverage and avoids complex rewiring
          </p>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12">
        <h1 class="main-heading">outcome</h1>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="integration-class">
          <p class="znap-p outcome-p">
            <ul>
                <li>Fast, plug-and-play experience for users setting up smart devices.</li>
                <li>Real-time energy usage monitoring with cost tracking.</li>
                <li>Full voice control through existing smart speakers.</li>
                <li>Cloud-connected smart devices with over-the-air update capability.</li>
            </ul>
          </p>
          <img src="/images/zimi/zimi-outcome.png" alt="" class="outcome-img">
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12" style="margin-top: 100px;">
        <img src="/images/zimi/zimi-gallery.png" alt="" class="outcome-img">
      </div>
      <!-- <div class="col-sm-12 col-md-12 col-lg-12" v-show="!isMobile">
        <div  class="grid-1">
      <div v-for="(slide, index) in slides" :key="index" >
        <img :src="slide" alt="Slide">
    </div>
  </div>
</div> -->
</div>

  </section>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
export default {
  name: 'ZnapshotCaseStudy',
  components: {
    VueSlickCarousel,
  },
  data(){
    return{
      slides: [
        "/images/znapshot/iphone 14 pro-4.png",
        "/images/znapshot/iphone 14 pro.png",
        "/images/znapshot/iphone 13.png",
        "/images/znapshot/iphone 14 pro-1.png",
        "/images/znapshot/iphone 14 pro-3.png"
      ],
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 0,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
        ],
      },
    };
  },    
  computed: {
    isMobile(){
      return window.matchMedia("(max-width: 480px)").matches;
    },  
  },

}
</script>

<style scoped>
.testimonial{
  position: relative;
  background-color: #151515;
  padding: 20px;
  border-radius: 20px;
  width: 100%;
  height: auto;
}
.testimonial .comment-flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.testimonial .testimonial-p{
  font-size: 14px;
  color: white;
  letter-spacing: 0.3px;
  font-weight: 600;
  line-height: 1.5;
}
.slider {
  position: relative;
  overflow: hidden;
  background: transparent;
}

.slides {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.slide {
  width: 100%;
  height: auto;

  
}

.slide-image {
  width: 80%;
  height: auto;
  margin: 10% 10%;
}


.second-grid .img {
  width: 100%;
  height: auto;
}
.center-img{
  width: 100%;
  width: auto;
  margin: 10% 0;
}
.center-img img{
  width: 100%;
  height: 100%;
}

.second-grid .img img {
  width: 100%;
  height: 100%;
}

.integration-class .comment-flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.main-heading span {
  color: rgb(46, 179, 127);
}

.comment-flex .img {
  width: 50px;
  height: auto;
  border-radius: 50%;
  margin-left: 0px;
  padding: 0px 10px 0px 0px;
}

.comment-flex .img img {

  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-size: cover;
  border: 1px solid #00b398;
}

.comment-flex p {
 color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0px !important;
  
}

.comment-flex span {
  
   color: #fff;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.2px;

}
.znap-p{
  text-align: left;
  font-size: 1.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.g2-img {
  margin-top: -50%;
  width: 100%;
  height: auto;
}

.g2-img img {
  width: 100%;
  height: 100%;
}

.full-img {
  width: 100%;
  height: auto;
  margin: 20px 0px;
}

.full-img img {
  height: 100%;
  width: 100%;
}

.integration-class {
  position: relative;
  background-color: #151515;
  padding: 50px;
  border-radius: 5rem;
  width: 100%;
  height: auto;
}
.integration-class .outcome-img{
  position: absolute;
  width: 30%;
  height: auto;
  bottom: 0;
  right: 0;
}
.integration-class .outcome-p {
  padding-right: 30%;
}

.integration-img {
  width: 100%;
  height: auto;
}

.integration-img img {
  width: 100%;
  height: 100%;
}

.second-grid .sub-heading span {
  color: rgb(46, 179, 127);
}

.second-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  height: auto;
  gap: 40px;
  padding: 10% 0;
  align-items: center;
}

.logo-img {
  padding: 20% 0px 10% 0px;
  width: 130px;
  height: 100%;
}

.second-grid .inrto-img {
  width: 100%;
  height: auto;
}

.second-grid .inrto-img img {
  width: 100%;
  height: 100%;
}


.second-grid .main-heading {
  font-size: 40px;
  font-weight: 800;
  letter-spacing: 0.5px;
  padding-bottom: 5px;
  line-height: 45px;
  text-transform: capitalize;
}

.main-heading {
  font-size: 40px;
  font-weight: 800;
  letter-spacing: 0.5px;
  padding-bottom: 5px;
  line-height: 45px;
  text-transform: capitalize;
}

.second-grid.sub-heading {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: capitalize;
}

.sub-heading {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: capitalize;
}

.tech-img {
  width: 70%;
  height: auto;
}
.tech-img .col-sm-2 img{
  width:100%;
  height: 100%;
}

.tech-img .tech-grid {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1.5fr 1.5fr 1.5fr;
  grid-template-rows: auto;
  gap: 2rem;
}
.tech-grid img{
  width: 100%;
  height: 100%;
}
.grid-1 {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: auto;
  gap: 20px;
  margin-top: 15%;
}

.grid-1 img {
  width: 100%;
  height: 100%;
}
.grid-1 div:nth-child(2) {
  margin-top: -50%;
  width: 100%;
  height: 100%;
}
.grid-1 div:nth-child(3) {
  margin-top: -70%;
  width: 100%;
  height: 100%;
}
.grid-1 div:nth-child(4) {
  margin-top: -50%;
  width: 100%;
  height: 100%;
}



.flex {
  width: 100%;
  height: auto;
  padding-top: 15%;
}

.flex img {
  width: 100%;
  height: 100%;
}




.primal-page .tech-grid img {
	width: auto !important;
	height: auto !important;
}
.primal-page .logo-img {
	width: 210px !important;
	padding-bottom: 20px !important;
}

.banner-right div {
	padding-top: 10px !important;
}

.banner-right img{
	width: 90%;
}
.banner-right {
	text-align: right;
}
.primal-page  .tech-img .tech-grid {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1.5fr 1.5fr 1.5fr;
  grid-template-columns: repeat(12, auto);
  grid-template-rows: auto;
  gap: 2rem;
}
.banner-right.zimi img {
	padding-top: 130px;
}





































@media(max-width: 768px) {

  .integration-class .outcome-img{
    display: none;
  }

  .integration-class .outcome-p {
    padding: 10px;
  }
  .second-grid.section-2 div:first-child{
    order: 0;
  }

  .second-grid {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    padding: 10px 15px;
  }

  .second-grid div:first-child {
    order: 1;
  }
  .inrto-img {
    width: 100%;
    height: auto;
    padding: 5px 0px;
  }

  .second-grid.main-heading {
    font-size: 30px;
    font-weight: 700;
  }

  .second-grid.sub-heading {
    font-size: 24px;
    font-weight: 700;
  }

  .logo-img {
    padding-top: 70px;
    width: 100px;
    height: 100%;
  }

}

@media(max-width: 480px) {
  .integration-class{
    padding: 10px 20px;
    border-radius: 20px;
  }
  .znap-p {
    font-size: 14px;
  color: white;
  letter-spacing: 0.3px;
  font-weight: 500;
  line-height: 1.7;
  text-align: justify;
  }
  .testimonial-p{
    text-align: justify;
    font-weight: 400;
  }
  .integration-img, .inrto-img {
    margin: 50px 0 45px 0;
  }
  
  .integration-class .znap-p {
    font-size: 14px;
  color: white;
  letter-spacing: 0.3px;
  font-weight: 500;
  line-height: 1.7;
  text-align: justify;

  }
  .integration-class .outcome-p {
    padding: 0;
  }

  .second-grid.main-heading {
    font-size: 20;
  }
  
  .integration-class .znap-p {
    font-size: 14px;
  color: white;
  letter-spacing: 0.3px;
  font-weight: 500;
  line-height: 1.7;
  text-align: justify;

  }

  .second-grid.sub-heading {
    font-size: 16px;
  }
  .g2-img{
    margin: 40px auto 20px;
  }
  .tech-img{
    width: 60%;
  }


}</style>
